export default __webpack_public_path__ + "static/media/Solitary Logical Learner.887144df.png";